import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Reveal from "./Reveal";

const CATS = [
  { id: "planes-fta", title: "Planes × FTA", cta: "Shop Collection", ctaTo: "/collection/planes-fta",
    images: Array.from({ length: 7 }, (_, i) => `/assets/categories/planes-fta/category-planes-fta-${String(i+1).padStart(2, "0")}.jpg`) },
  { id: "popup-experience", title: "Pop-Up Experience", cta: "Inquire to Host", ctaTo: "/pop-up-experience",
    images: [
      "/assets/categories/popup-experience/category-popup-experience-04.jpg",
      "/assets/categories/popup-experience/category-popup-experience-02.webp",
      "/assets/categories/popup-experience/category-popup-experience-03.webp",
    ]},
  // Fall Collection tile uses ONE composite image only (per correction pass) —
  // the burgundy Thinkers tee + white Freedom Thinkers Academy tee + black hat.
  // Do NOT convert this to a slideshow.
  { id: "fta-fall", title: "FTA Fall Collection", cta: "Shop Collection", ctaTo: "/collection/fta-fall",
    images: ["/assets/categories/fta-fall/category-fta-fall-01.jpg"] },
];

function Slideshow({ images }) {
  const [i, setI] = useState(0);
  const [touchX, setTouchX] = useState(null);
  // Single-image tiles skip the interval and swipe logic entirely.
  useEffect(() => {
    if (images.length < 2) return;
    const t = setInterval(() => setI(x => (x + 1) % images.length), 4500);
    return () => clearInterval(t);
  }, [images.length]);
  return (
    <div className="relative w-full aspect-[4/5] md:aspect-[3/4] overflow-hidden bg-neutral-950"
      onTouchStart={(e) => { if (images.length > 1) setTouchX(e.touches[0].clientX); }}
      onTouchEnd={(e) => { if (images.length < 2 || touchX==null) return; const dx = e.changedTouches[0].clientX-touchX; if (Math.abs(dx)>40) setI(x => (x + (dx<0?1:-1) + images.length) % images.length); setTouchX(null); }}>
      <AnimatePresence>
        <motion.img key={i} src={images[i]} alt="" loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.8 }} />
      </AnimatePresence>
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/85 via-black/40 to-transparent" />
    </div>
  );
}

export default function CategoryShowcase() {
  return (
    <section id="categories" data-testid="categories-section" className="relative bg-black text-white py-20 md:py-28">
      <div className="px-4 md:px-10 max-w-[1400px] mx-auto mb-10 md:mb-14">
        <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F4C10A] mb-3">Shop by Experience</div>
        <h2 className="font-wide uppercase text-4xl sm:text-5xl md:text-6xl">Categories</h2>
      </div>
      <div className="px-4 md:px-10 max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {CATS.map((c, i) => (
          <Reveal key={c.id} delayMs={i * 80} data-testid={`category-card-${c.id}`} className="relative group">
            <Slideshow images={c.images} />
            <div className="absolute left-0 right-0 bottom-0 p-5 md:p-6">
              <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-[#F4C10A] mb-1">Category</div>
              <div className="font-wide uppercase text-white text-2xl md:text-3xl leading-tight">{c.title}</div>
              <Link to={c.ctaTo} data-testid={`category-cta-${c.id}`}
                className="mt-4 inline-flex items-center justify-center bg-[#F4C10A] text-black font-display uppercase text-xs tracking-[0.22em] px-6 py-2.5 hover:bg-white transition-colors">
                {c.cta}
              </Link>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
